<template>
    <v-card>
        <v-card-title>
        <span class="headline">Claim Sub Type</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
        <form>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 sm6 v-if="mode === 'new'">
                <v-autocomplete :items="appIdList" v-model="selectedClmSubType.appId" :label="labels.appId" item-text="label" item-value="value"
                  data-vv-name="appId" :data-vv-as="labels.appId" :error-messages="errors.collect('appId')" v-validate="'required'" @change="selectedClmSubType.clmType=undefined"/>
              </v-flex>
              <v-flex xs12 sm6 v-if="mode === 'review' || mode === 'query'">
                <v-subheader class="queryLabel">{{labels.appId}}</v-subheader>
                <div class="title">{{appId[selectedClmSubType.appId]}}</div>
              </v-flex>
              <v-flex xs12 v-if="mode === 'new'">
                <v-autocomplete v-model="selectedClmSubType.clmType" :label="labels.clmType" :error-messages="errors.collect('clmType')" v-validate="'required'"
                  data-vv-name="clmType" :data-vv-as="labels.clmType" :items="filteredClmTypeList" item-text="label" item-value="clmType" :loading="loading"/>
              </v-flex>
              <v-flex xs12 v-if="mode === 'review' || mode === 'query'">
                <v-subheader class="queryLabel">{{labels.clmType}}</v-subheader>
                <div class="title">{{clmTypeMap[selectedClmSubType.clmType]}}</div>
              </v-flex>
              <v-flex xs12 sm6 v-if="mode === 'new'">
                <v-text-field v-model="selectedClmSubType.clmSubType" :label="labels.clmSubType" :error-messages="errors.collect('clmSubType')" v-validate="'required|max:4'"
                  data-vv-name="clmSubType" :data-vv-as="labels.clmSubType"/>
              </v-flex>
              <v-flex xs12 sm6 v-if="mode === 'review' || mode === 'query'">
                <v-subheader class="queryLabel">{{labels.clmSubType}}</v-subheader>
                <div class="title">{{selectedClmSubType.clmSubType}}</div>
              </v-flex>
              <v-flex xs12 sm6>
                <v-autocomplete v-if="mode === 'review' || mode === 'new'" v-model="selectedClmSubType.seqNo" :label="labels.seqNo" :error-messages="errors.collect('seqNo')" v-validate="'required|numeric|min:0|max_value:999'"
                  data-vv-name="seqNo" :data-vv-as="labels.seqNo" :items="seqNoList" item-text="label" item-value="value" />
                <v-subheader v-if="mode === 'query'" class="queryLabel">{{labels.seqNo}}</v-subheader>
                <div v-if="mode === 'query'" class="title">{{selectedClmSubType.seqNo}}</div>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field v-if="mode === 'review' || mode === 'new'" v-model="selectedClmSubType.clmSubTypeDesc" :label="labels.clmSubTypeDesc" :error-messages="errors.collect('clmSubTypeDesc')"
                  v-validate="'required|max:200'" data-vv-name="clmSubTypeDesc" :data-vv-as="labels.clmSubTypeDesc"/>
                <v-subheader v-if="mode === 'query'" class="queryLabel">{{labels.clmSubTypeDesc}}</v-subheader>
                <div v-if="mode === 'query'" class="title">{{selectedClmSubType.clmSubTypeDesc}}</div>
              </v-flex>
              <v-flex xs12 sm6>
                <v-checkbox :readonly="mode === 'query'" v-model="selectedClmSubType.permMultiClmt" :label="labels.permMultiClmt" data-vv-name="permMultiClmt"
                  :data-vv-as="labels.permMultiClmt" :error-messages="errors.collect('permMultiClmt')"/>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel" :disabled="submitting">Cancel</v-btn>
        <v-btn color="primary" v-if="mode === 'review' || mode === 'new'" flat @click.native="doSave" :loading="submitting">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  props: {
    'selectedClmSubType': Object,
    'mode': String
  },
  data() {
    return {
      labels: {
        appId: 'Module',
        clmType: 'Claim Type*',
        clmSubType: 'Claim Sub Type*',
        clmSubTypeDesc: 'Description*',
        seqNo: 'Sequence No.*',
        permMultiClmt: 'Permit multiple claimants'
      },
      clmTypeList: [],
      seqNoList: [],
      clmTypeMap: {},
      appId: {
        'TR': 'Travel',
        'MD': 'Maid',
        'FI': 'Fire'
      },
      loading: false,
      submitting: undefined
    }
  },
  created() {
    this.seqNoList = []
    for (var i = 1; i < 21; i++) {
      this.seqNoList.push({ label: '' + i, value: i })
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    appIdList() {
      let result = []
      let appID = this.appId
      Object.keys(appID).forEach(function (key) {
        const status = appID[key]
        result.push({
          label: key + ' - ' + status,
          value: key
        })
      })
      return result
    },
    filteredClmTypeList() {
      return this.clmTypeList.filter(x => {
        return x.appId === this.selectedClmSubType.appId
      })
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.loadClaimTypes()
    },
    async loadClaimTypes() {
      this.loading = true
      const apiUrl = this.$store.state.claimParam.menu.getClmTypes
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.clmTypeList = []
            data.map((clmType) => {
              clmType.label = clmType.clmType + ' - ' + clmType.clmTypeDesc
              this.clmTypeList.push(clmType)
              this.clmTypeMap[clmType.clmType] = clmType.label
            })
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Unable to retrieve claim types (Missing API URL)')
      }
      this.loading = false
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.mode === 'new') this.doCreate()
          if (this.mode === 'review') this.doUpdate()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.claimParam.menu.createClmSubType
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.selectedClmSubType)
          const { data } = result
          if (data.clmSubType) {
            this.notify(data)
            this.$emit('fetchData')
            this.$emit('close')
          } else {
            this.notify(data)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Unable to create claim sub type (Missing API URL)')
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.claimParam.menu.updateClmSubType
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.selectedClmSubType)
          const { data } = result
          if (data.clmSubType) {
            this.notify(data)
            this.$emit('fetchData')
            this.$emit('close')
          } else {
            this.notify(data)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      } else {
        this.$snotify.error('Unable to update claim sub type (Missing API URL)')
      }
    },
    doCancel() {
      this.resetMessages()
      this.$emit('close')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
